import { defineMessages } from 'react-intl';

export default defineMessages({
    changesMade: {
        id: 'agency.admin.views.messages.changesMade',
        defaultMessage: 'Changes made do not automatically update in our legacy Agent Portal.'
    },
    youMay: {
        id: 'agency.admin.views.messages.youMay',
        defaultMessage: 'You may login to the legacy Agent Portal to make changes or contact TWIA at agentservices@twia.org.'
    },
    changesNotSaved:{
        id: 'agency.admin.views.messages.changesNotSaved',
        defaultMessage: 'Changes will not be saved'
    },
    exitWithoutSubmit:{
        id: 'agency.admin.views.messages.exitWithoutSubmit',
        defaultMessage: 'Are you sure you want to exit without submitting?'
    },
    cancel:{
        id: 'agency.admin.views.messages.cancel',
        defaultMessage: 'Cancel'
    },
    ok:{
        id: 'agency.admin.views.messages.ok',
        defaultMessage: 'OK'
    },
    invalidBank: {
        id: 'twia.gateway.views.selfservice.eftpayments.Bad Bank Info Title',
        defaultMessage: 'Invalid Bank Information'
    },
    badBank: {
        id: 'twia.gateway.views.selfservice.eftpayments.badBank',
        defaultMessage: 'The routing or account information is incorrect. Please retype valid information.'
    },
    deactivatePopupTitle: {
        id: 'twia.gateway.views.selfservice.eftpayments.deactivatePopupTitle',
        defaultMessage: 'Deactivate EFT Payments'
    },
    deactivateFail: {
        id: 'twia.gateway.views.selfservice.eftpayments.deactivateFail',
        defaultMessage: 'Unable to Deactivate EFT Status, Please Contact Administrator'
    },
    deactivatePopupMsg: {
        id: 'twia.gateway.views.selfservice.eftpayments.deactivatePopupMsg',
        defaultMessage: 'You will no longer be able to make EFT Payments. Are you sure?'
    },
    activateFail: {
        id: 'twia.gateway.views.selfservice.eftpayments.activateFail',
        defaultMessage: 'Unable to Activate EFT Status, Please Contact Administrator'
    },
    updateFailTitle: {
        id: 'twia.gateway.views.selfservice.eftpayments.updateFailTitle',
        defaultMessage: 'Unable to Update EFT Payments'
    },
    updateFailMessage: {
        id: 'twia.gateway.views.selfservice.eftpayments.updateFailMessage',
        defaultMessage: 'Unable to Update EFT Payments, Please Contact Administrator'
    },
    activateFailTitle: {
        id: "twia.gateway.views.selfservice.eftpayments.Activate Failed Title",
        defaultMessage: "Unable to Activate EFT Status"
    },
    deActivateFailTitle: {
        id: "twia.gateway.views.selfservice.eftpayments.deActivateFailTitle",
        defaultMessage: "Unable to Deactivate EFT Status"
    }
});